export default "__VITE_ASSET__e9f9c498__"